module.exports = __webpack_public_path__ + "static/introduce-line.9bc2c91a.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/introduce-line.png
// module id = 1025
// module chunks = 2